import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.png';
import CImage from '../../images/case-single/img-1.jpg';

const ZEFFY_FORM_ID = '0c9fb016-0dd9-4d73-bd8d-e7b03fef2de9';

const Donate = () => {
  return (
    <Fragment>
      <Navbar hclass={'header-style-1'} Logo={Logo} btnClass={'theme-btn-s1'} />
      <PageTitle pageTitle="Support Our Community" pagesub="Help Us Make a Difference" />

      <section className="case-single-section section-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col col-xl-7 col-lg-7 col-12">
              <div className="img-holder details-img">
                <img src={CImage} alt="Roslindale Food Collective volunteers" />
              </div>
            </div>
            <div className="col col-xl-5 col-lg-5 col-12">
              <div className="case-info-area">
                <h3>Join Us in Nourishing Our Community</h3>
                <p>At Roslindale Food Collective, we believe in the power of community support to make a difference in times of need. Our mission is to collect and distribute food to those who face food insecurity, ensuring that every member of our community has access to nutritious meals. Your donation today helps us extend our reach, provide more food, and bring hope to families and individuals. Together, we can create a stronger, healthier community for all.</p>
              </div>
            </div>
          </div>

          <div className="row donate-area-bottom">
            <div className="col col-12">
              <div
                className="donate-area-wrapper"
                style={{ maxWidth: '760px', margin: '0 auto', width: '100%' }}
              >
                <h2
                  className="nonprofit-status text-center"
                  style={{
                    color: '#48894C',
                    animation: 'glow 2s ease-in-out infinite',
                    marginBottom: '24px',
                    fontSize: '24px',
                    fontWeight: '600',
                  }}
                >
                  501(c)3: 93-4951322
                </h2>

                <div
                  style={{
                    width: '100%',
                    height: '560px',
                  }}
                >
                  <iframe
                    title="Donation form powered by Zeffy"
                    style={{
                      border: '0',
                      width: '100%',
                      height: '100%',
                      display: 'block',
                    }}
                    src={`https://www.zeffy.com/embed/donation-form/${ZEFFY_FORM_ID}`}
                    allowPaymentRequest
                    allowTransparency="true"
                  />
                </div>

                <p className="text-center mt-3">
                  Si el formulario no se muestra correctamente,{' '}
                  <a
                    href={`https://www.zeffy.com/donation-form/${ZEFFY_FORM_ID}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    haz clic aquí para donar directamente
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
      <Scrollbar />
    </Fragment>
  );
};

export default Donate;
